import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnCurrentOrganization } from '@lib/auth';
import { SnDataListComponent } from '@lib/ui/data-list';

import { LprReadsAPI, SnLprRead } from '../../api';
import { FlockLprService } from '../../integrations';

@Component({
  selector: 'sn-recent-hit-dialog',
  templateUrl: './recent-hit-dialog.component.html',
  styleUrls: ['./recent-hit-dialog.component.scss'],
})
export class RecentHitDialogComponent implements OnInit, OnDestroy {
  public timeStamp: any;
  public activeIndex: number = 0;
  public count: number = 0;

  public readonly list: SnDataListComponent<SnLprRead>;
  public readonly loadData = this._loadData.bind(this);

  get flockEnabled(): boolean {
    return this._currentOrganization.enabledIntegrations.includes('flock');
  }

  private readonly _destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<RecentHitDialogComponent>,
    private readonly _readsApi: LprReadsAPI,
    private readonly _flockLprAPI: FlockLprService,
    private readonly _currentOrganization: SnCurrentOrganization,
  ) {}

  public ngOnInit(): void {
    if (this.data.createdTimestamp) {
      this.timeStamp = new Date(this.data.createdTimestamp).getTime();

      this._loadData({
        details__camera_name: this.data.cameraName,
        created_timestamp__lte: this.timeStamp,
        pageSize: 10,
      });
    }

    if (!this.data.createdTimestamp) {
      this._loadData({
        details__camera_name: this.data.cameraName,
        pageSize: 10,
      });
    }
  }

  public close(): void {
    this._dialogRef.close();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._flockLprAPI.destroy();
  }

  private _loadData(params: ISnListQueryParameters): Observable<ISnListResponse<SnLprRead>> {
    if (this.flockEnabled && this.data?.cameras?.length) {
      const queryParams: any = {
        ...params,
        plate: '*',
      };
      if (this.data.point && this.data.radius) {
        queryParams.point = this.data.point;
        queryParams.dist = this.data.radius;
      } else {
        queryParams.cameras = this.data.cameras.join();
        queryParams.omitPosition = true;
      }
      return this._flockLprAPI
        .getFlockPlates({
          ...queryParams,
        })
        .pipe(
          tap((response) => {
            this.count = response.count;
          }),
          takeUntil(this._destroy$),
        );
    }
    return this._readsApi
      .getReadsList({
        ...params,
        details__camera_name: this.data.cameraName,
        created_timestamp__lte: this.timeStamp,
        pageSize: 10,
      })
      .pipe(
        tap((response) => {
          this.count = response.count;
        }),
        takeUntil(this._destroy$),
      );
  }
}
